/* TAVIA: use Shopify media order instead of stale single-image Globo assignments. */
(function () {
  const config = window.GloboSwatchConfig;
  if (!config || !window.location.pathname.endsWith('/products/gartenstuhle-tavia-im-2er-oder-4er-set-stapelbar-fur-garten-und-terrasse')) return;
  let entries = config.variant_image_products;
  if (typeof entries === 'string') { try { entries = JSON.parse(entries); } catch (_) { return; } }
  if (Array.isArray(entries)) config.variant_image_products = entries.filter(entry => String(entry.product_id) !== '16223489950045');
  // Globo's gallery reads the first variant for an option, ignoring the other option.
  // Resolve the complete color + set combination before its change handler runs.
  document.addEventListener('change', function(event) {
    const input = event.target;
    const root = input.closest?.('.globo-swatch-product-detail');
    if (!root || !input.matches('input[type="radio"]')) return;
    const color = root.querySelector('input[name="globo-option-0"]:checked')?.value;
    const size = root.querySelector('input[name="globo-option-1"]:checked')?.value;
    const variants = {
      'Schwarz|4 Stück':'64797540024669', 'Schwarz|2 Stück':'64797540057437',
      'Dunkelgrau|4 Stück':'64797540090205', 'Dunkelgrau|2 Stück':'64797540122973',
      'Braun|4 Stück':'64797540155741', 'Braun|2 Stück':'64797540188509'
    };
    const id = variants[color + '|' + size];
    if (id) input.closest('li.select-option')?.setAttribute('data-variantId', id);
  }, true);
})();
